module.exports = __webpack_public_path__ + "img/003.c3ea20b7.png";